/*
 * Melhorias dos cards de produto nos carrosséis da Home:
 * 1) Setas para navegar entre as imagens do produto (sem abrir a PDP, sem mover o carrossel).
 * 2) Quick add: clicar direto no tamanho adiciona a variante ao carrinho.
 * 3) Preview da 2ª imagem no hover.
 * 4) Carrossel horizontal com drag (desktop) / swipe nativo (mobile), com "peek" do
 *    próximo produto — sem confundir com clique/PDP/Quick Add/setas.
 *
 * Delegação de eventos em document, carregado uma única vez (ver layout/theme.liquid).
 * Só age em elementos que tenham os atributos data-* abaixo — presentes apenas nos
 * carrosséis de produtos da Home (snippets/product-card.liquid com enable_enhancements,
 * sections/product-grid.liquid e sections/collection-banner-grid.liquid). Não afeta
 * Product Page, Collections, Search.
 */
(function () {
  if (window.__pcEnhancedInit) return;
  window.__pcEnhancedInit = true;

  function handleGalleryNav(target) {
    var prevBtn = target.closest('[data-gallery-prev]');
    var nextBtn = target.closest('[data-gallery-next]');
    if (!prevBtn && !nextBtn) return false;

    var galleryRoot = (prevBtn || nextBtn).closest('[data-gallery]');
    if (!galleryRoot) return true;

    var frames = Array.prototype.slice.call(galleryRoot.querySelectorAll('[data-gallery-frame]'));
    if (frames.length < 2) return true;

    var current = 0;
    frames.forEach(function (frame, i) {
      if (frame.classList.contains('is-active')) current = i;
    });
    var next = prevBtn ? (current - 1 + frames.length) % frames.length : (current + 1) % frames.length;
    frames.forEach(function (frame, i) {
      frame.classList.toggle('is-active', i === next);
    });
    return true;
  }

  function handleQuickAdd(target) {
    var addBtn = target.closest('[data-quick-add]');
    if (!addBtn) return false;
    if (addBtn.disabled) return true;

    var group = addBtn.closest('[data-quickadd-group]');
    if (!group || group.classList.contains('is-busy')) return true;

    var variantId = addBtn.dataset.variantId;
    if (!variantId) return true;

    var label = group.querySelector('[data-quickadd-label]');
    var originalLabel = label ? label.textContent : null;
    var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-quick-add]'));

    group.classList.add('is-busy');
    buttons.forEach(function (b) { b.disabled = true; });
    if (label) label.textContent = 'Adicionando…';

    function restore() {
      group.classList.remove('is-busy');
      buttons.forEach(function (b) {
        if (b.dataset.available !== 'false') b.disabled = false;
      });
      if (label) label.textContent = originalLabel;
    }

    /* Estado único do carrinho (assets/cart-drawer.js): 1 requisição de add que já
       sincroniza drawer, contador, subtotal e frete, e abre o drawer. */
    if (!window.ErmosCart) { restore(); return true; }
    window.ErmosCart.add([{ id: variantId, quantity: 1 }])
      .then(function () {
        if (label) label.textContent = 'Adicionado ✓';
        setTimeout(restore, 1400);
      })
      .catch(function () {
        restore();
      });

    return true;
  }

  /* ---------- Carrossel: setas no desktop ---------- */
  /* Uma "página" = 80% da largura visível, para sempre sobrar um card de referência.
     scroll-behavior: smooth está no CSS, então basta mexer no scrollLeft. */
  function pageFor(track) { return Math.max(160, Math.round(track.clientWidth * 0.8)); }

  function syncArrows(section) {
    var track = section.querySelector('[data-carousel-track]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    section.querySelectorAll('[data-carousel-arrow]').forEach(function (btn) {
      var dir = Number(btn.getAttribute('data-carousel-arrow'));
      // 2px de folga: scrollLeft fracionário nunca bate exatamente no limite.
      btn.hidden = max <= 2 || (dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2);
    });
  }

  function initCarouselArrows() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-carousel-arrow]');
      if (!btn) return;
      var section = btn.closest('.product-grid');
      var track = section && section.querySelector('[data-carousel-track]');
      if (!track) return;
      track.scrollLeft += pageFor(track) * Number(btn.getAttribute('data-carousel-arrow'));
    });

    document.querySelectorAll('.product-grid').forEach(function (section) {
      var track = section.querySelector('[data-carousel-track]');
      if (!track) return;
      syncArrows(section);
      track.addEventListener('scroll', function () { syncArrows(section); }, { passive: true });
      window.addEventListener('resize', function () { syncArrows(section); });
      // As imagens dos cards chegam depois e mudam o scrollWidth.
      window.addEventListener('load', function () { syncArrows(section); });
    });
  }

  /* Fase de CAPTURA: precisa rodar antes do onclick inline (preventDefault/stopPropagation)
     que já existe nos elementos do card (setas e sizebar), senão o clique nunca chegaria
     até este listener delegado em document. */
  document.addEventListener('click', function (e) {
    if (handleGalleryNav(e.target)) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (handleQuickAdd(e.target)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  /* Ao passar o mouse na primeira foto, mostra a segunda imagem (se houver);
     ao tirar o mouse, volta para a primeira. Independente da navegação manual pelas setas. */
  function setActiveFrame(galleryRoot, index) {
    var frames = Array.prototype.slice.call(galleryRoot.querySelectorAll('[data-gallery-frame]'));
    if (!frames.length) return;
    var normalized = ((index % frames.length) + frames.length) % frames.length;
    frames.forEach(function (frame, i) {
      frame.classList.toggle('is-active', i === normalized);
    });
  }

  /* Em touch, mouseenter e disparado pelo proprio toque; trocar a imagem ai e uma
     mudanca de conteudo que o Safari iOS interpreta como "menu de hover" e segura o
     clique. O preview por hover so faz sentido com mouse/trackpad. */
  var hasRealHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initHoverPreview(root) {
    if (!hasRealHover) return;
    var scope = root || document;
    var galleries = scope.querySelectorAll('[data-gallery]');
    galleries.forEach(function (gallery) {
      if (gallery.dataset.hoverInit === '1') return;
      var frameCount = gallery.querySelectorAll('[data-gallery-frame]').length;
      if (frameCount < 2) return;
      gallery.dataset.hoverInit = '1';
      gallery.addEventListener('mouseenter', function () {
        setActiveFrame(gallery, 1);
      });
      gallery.addEventListener('mouseleave', function () {
        setActiveFrame(gallery, 0);
      });
    });
  }

  function init() {
    initHoverPreview();
    initCarouselArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Hook para reinicializar o hover preview em cards injetados via AJAX
     (ex.: grid da Collection Page após filtro/ordenação). Não afeta o
     comportamento existente — apenas religa listeners em elementos novos,
     com guarda para nunca duplicar em elementos já inicializados. */
  document.addEventListener('ermos:cards:refresh', function (e) {
    initHoverPreview(e.detail && e.detail.root);
  });

  /* Theme Editor: section adicionada/recarregada => liga o hover preview nos cards novos
     (idempotente: a guarda data-hover-init impede listener duplicado). */
  document.addEventListener('shopify:section:load', function (e) {
    initHoverPreview(e.target);
  });
})();
